export const SUBSCRIBER_COLOR = "#4f7cac";
export const SUBSCRIBER_COLOR_LIGHT = "#7296bd";
